import React from 'react'

const TablaCancelarSuministro = ({item,passDataSeleccionarMotivo}) => {
    const dataSeleccionarMotivo={
      PQConTip: item.ConTip,
      PQConCod:item.ConCod,
      ConDsc:item.ConDsc
    }
    const seleccionarCancelarSuministro=()=>{
      passDataSeleccionarMotivo(dataSeleccionarMotivo)
    }
  return (
    <tbody>
      <tr className=" divide-y divide-slate-700 ">
        <td></td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
          <button
            onClick={seleccionarCancelarSuministro}
            type="button"
            className="inline-block px-2 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
          >
            Seleccionar
          </button>
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.ConCod}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.ConDsc}
        </td>
      </tr>
      
    </tbody>
  )
}

export default TablaCancelarSuministro